export default __webpack_public_path__ + "assets/webgl/picking-7.69016fbe.glb";